import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const cancelPicking = {
  name: "cancelPicking" as const,
  input: z.object({ fulfillmentGroupId: zExt.objectId() }),
  output: z.object({ success: z.boolean(), message: z.string().nullish() }),
};
